import React from "react";
import { Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface Props {
  emails: { label: string; value: string }[];
  onRemove: (index: number) => void;
}

const SelectedEmailsList: React.FC<Props> = ({ emails, onRemove }) => {
  if (!emails.length) return null;

  return (
    <>
      <label>Email(s) ajoutés</label>
      <div className="mb-3 form-control" style={{ maxHeight: 100, overflowY: "auto" }}>
        {emails.map((email, index) => (
          <Tag key={email.value}>
            {email.label}
            <FontAwesomeIcon
              icon={faTimes}
              className="ms-2 cursor-pointer"
              onClick={() => onRemove(index)}
            />
          </Tag>
        ))}
      </div>
    </>
  );
};

export default SelectedEmailsList;
